import analytics from '@nerdwallet/analytics';
import qs from 'querystring';
import { NOT_DESKTOP_MAX_WIDTH } from '../auth/lib/constants';
import { VERSION } from '../constants';

import { tryWithSentry } from './sentry';

const isMobile = () => window.innerWidth <= NOT_DESKTOP_MAX_WIDTH;

export const addTrkParams = ({
  link,
  additionalParams,
}: {
  link: string;
  additionalParams?: { [s: string]: string | number };
}): string => {
  if (!link || typeof link !== 'string') {
    throw new Error('Invalid link passed to addTrkParams');
  }

  const [base, hash] = link.split('#');
  const hasParam = base.includes('?');

  const versionQueryString = `trk=nw_gn_${VERSION}`;

  let final = base;
  final += `${hasParam ? '&' : `?`}${versionQueryString}`;

  if (additionalParams) {
    final += `&${qs.encode(additionalParams)}`;
  }
  final += hash ? `#${hash}` : '';

  return final;
};

export const trackBentoInteraction = {
  bedrock: () => {
    tryWithSentry(() => {
      analytics.track('navigation_item_interacted', {
        interaction_id: analytics.uuid(),
        entity_name: 'global_nav_bento',
        action: 'open',
        interaction_type: isMobile() ? 'press' : 'hover',
        navigation_component: 'global_header_bento',
        navigation_format: 'header',
        item_level: 1,
      });
    });
  },
};

/*
 * Track general element interactions.
 */
export const trackElementInteraction = {
  bedrock: ({
    entityName,
    action,
    impressionId,
    interactionType,
  }: {
    entityName: string;
    action: string;
    impressionId?: string;
    interactionType: string;
  }) => {
    tryWithSentry(() => {
      analytics.track('element_interacted', {
        entity_name: entityName,
        interaction_id: analytics.uuid(),
        impression_id: impressionId,
        interaction_type: interactionType,
        action,
      });
    });
  },
};
